var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuoteClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.01 56 52.01"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M33 52l-3.167-4.587c8-6.628 12.667-11.386 16.334-20.393l-4.833-4.42c-5-4.419-6.5-8.327-6.5-12.576C34.834 3.229 38.667 0 44.666 0a12.257 12.257 0 019 3.4A32.351 32.351 0 0156 15.463C56 30.249 45.5 43.843 33 52M3.167 52L0 47.413c8-6.628 12.667-11.386 16.334-20.393L11.5 22.6C6.5 18.183 5 14.274 5 10.025 5 3.229 8.832 0 14.833 0a12.262 12.262 0 019 3.4 32.379 32.379 0 012.333 12.065c0 14.785-10.5 28.379-23 36.537"
  })));
}

export default SvgQuoteClose;